import { AgSleeveComponent, currencyFixedAmountCellValueGetter, currencyKeyedAmountCellValueGetter, currencyPairAmountCellComparator, CurrencyPairAmountCellRendererComponent, currencyPairAmountCellValueFormatter, currencyPairAmountCellValueGetter, getSleeveClass, rateCellKeyCreator, RateCellRendererComponent, StringCellRendererComponent, } from '../cell-renderer';
import { dateCellFormatter, datetimeCellFormatter, noValueSkipperFormatter, numberCellFormatter, rateCellFormatter, } from '../cell-formatter';
import { objectKeyCreator } from '../ag-groups';
export const STANDARD_COLUMN_TYPE = {
    cellClass: ['standard-cell'],
};
export const STATUS_COLUMN_TYPE = {
    cellClass: ['status-cell'],
};
export const STRING_COLUMN_TYPE = {
    cellClass: ['string-cell'],
    cellRenderer: StringCellRendererComponent,
};
export const DATE_COLUMN_TYPE = {
    cellClass: ['date-cell'],
    valueFormatter: noValueSkipperFormatter(dateCellFormatter),
    cellRenderer: StringCellRendererComponent,
};
export const DATETIME_COLUMN_TYPE = {
    cellClass: ['datetime-cell'],
    valueFormatter: noValueSkipperFormatter(datetimeCellFormatter),
};
export const NUMBER_COLUMN_TYPE = {
    cellClass: ['number-cell'],
    valueFormatter: noValueSkipperFormatter(numberCellFormatter),
};
export const AMOUNT_COLUMN_TYPE = {
    cellClass: ['amount-cell'],
    valueFormatter: currencyPairAmountCellValueFormatter,
    cellRenderer: CurrencyPairAmountCellRendererComponent,
    keyCreator: objectKeyCreator,
    valueGetter: currencyPairAmountCellValueGetter,
    comparator: currencyPairAmountCellComparator,
};
export const AMOUNT_BASE_CURRENCY_COLUMN_TYPE = {
    valueGetter: currencyPairAmountCellValueGetter,
    cellRendererParams: {
        currenciesSplitKey: 'CurrencyPair',
        getCurrencyFromCurrenciesSplit: ({ currencyBase }) => currencyBase,
    },
};
export const AMOUNT_QUOTE_CURRENCY_COLUMN_TYPE = {
    valueGetter: currencyPairAmountCellValueGetter,
    cellRendererParams: {
        currenciesSplitKey: 'CurrencyPair',
        getCurrencyFromCurrenciesSplit: ({ currencyQuote }) => currencyQuote,
    },
};
export const AMOUNT_FIXED_CURRENCY_COLUMN_TYPE = {
    valueGetter: currencyFixedAmountCellValueGetter,
    cellRendererParams: {
        fixedCurrency: ' ',
    },
};
export const AMOUNT_KEYED_CURRENCY_COLUMN_TYPE = {
    valueGetter: currencyKeyedAmountCellValueGetter,
    cellRendererParams: {
        currencyKey: 'BaseCurrency',
    },
};
export const RATE_COLUMN_TYPE = {
    cellClass: ['rate-cell'],
    valueFormatter: noValueSkipperFormatter(rateCellFormatter),
    cellRenderer: RateCellRendererComponent,
    keyCreator: rateCellKeyCreator,
};
export const AMOUNT_NEGATIVE_COLUMN_TYPE = {
    cellClass: ({ value }) => {
        return ['amount'].concat(value < 0 ? ['negative-cell'] : []);
    },
};
export const SLEEVE_COLUMN_TYPE = {
    cellClass: ['sleeve-cell'],
    cellRenderer: AgSleeveComponent,
    cellRendererParams: {
        getSleeveClass,
        getSleeveValue: (value) => value,
    },
};
/**
 * Some column types __need to be associate with a base column type__ in order to work as expected.
 * For example, if you want to use the 'amount_base-currency' column type, you will need to also have
 * the 'amount' column type.
 *
 * ```javascript
 * columnDefs: [
 *   {
 *     type: [ 'amount', 'amount-base' ],
 *     headerName: 'Amount (Base ccy)',
 *     field: 'PositionAmtCcy1',
 *   },
 * ]
 * ```
 */
export const COLUMN_TYPES_DEFAULT = {
    'standard': STANDARD_COLUMN_TYPE,
    'status': STATUS_COLUMN_TYPE,
    'string': STRING_COLUMN_TYPE,
    'date': DATE_COLUMN_TYPE,
    'datetime': DATETIME_COLUMN_TYPE,
    'number': NUMBER_COLUMN_TYPE,
    'amount': AMOUNT_COLUMN_TYPE,
    'amount_base-currency': AMOUNT_BASE_CURRENCY_COLUMN_TYPE,
    'amount_quote-currency': AMOUNT_QUOTE_CURRENCY_COLUMN_TYPE,
    'amount_fixed-currency': AMOUNT_FIXED_CURRENCY_COLUMN_TYPE,
    'amount_keyed-currency': AMOUNT_KEYED_CURRENCY_COLUMN_TYPE,
    'rate': RATE_COLUMN_TYPE,
    'amount_negative': AMOUNT_NEGATIVE_COLUMN_TYPE,
    'sleeve': SLEEVE_COLUMN_TYPE,
};
